import authService from './authService';

// ─── Types ──────────────────────────────────────────────────────

export interface StockMovementProduct {
  sku: string;
  description: string;
  stock_quantity: number | null;
  previous_stock_quantity: number | null;
}

export interface StockMovementOrderItem {
  sku: string;
  description: string;
  quantity: number;
  order_id: number;
  order_num_erp: number;
}

export interface StockMovementReceiptItem {
  sku: string;
  description: string;
  quantity: number;
  material_receipt_id: number;
}

export interface StockMovementReconciliationRow {
  sku: string;
  description: string;
  previous_stock_quantity: number | null;
  current_stock_quantity: number | null;
  order_items_stock_qty: number;
  receipt_items_qty: number;
  calculated_stock_quantity: number | null;
  stock_quantity_diff: number | null;
}

export interface StockMovementReportResponse {
  date: string;
  products: StockMovementProduct[];
  stock_updated_order_items: StockMovementOrderItem[];
  receipt_items: StockMovementReceiptItem[];
  reconciliation: StockMovementReconciliationRow[];
}

// ─── Service ────────────────────────────────────────────────────

class StockMovementReportService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  async getReport(date: string): Promise<StockMovementReportResponse> {
    const params = new URLSearchParams({ date });
    const apiClient = await this.getApiClient();
    const response = await apiClient.get(`/reports/stock-movements?${params}`);
    if (!response.ok) throw new Error('Erro ao carregar relatório de movimentações de estoque');
    return response.json();
  }
}

export const stockMovementReportService = new StockMovementReportService();
export default stockMovementReportService;
